import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { ExclusionType } from '../../definitions';
import type { ExclusionResponseProps as Props } from '../../definitions';
import DefaultBreakResponse from '../DefaultBreakResponse/DefaultBreakResponse';
import DefaultSelfExclusionResponse from '../DefaultSelfExclusionResponse/DefaultSelfExclusionResponse';

import { TXTWCL_This_means_you_can_no_longer_p_ELL } from './ExclusionResponseIT.messages.json';

const ExclusionResponseIT: React.FC<Props> = ({ daysRequested, exclusionType, endDate }) => {
  const nationalExclusion = useSelector(select.account.bannedByRegulator);

  switch (true) {
    case nationalExclusion:
      return <Translation {...TXTWCL_This_means_you_can_no_longer_p_ELL} />;
    case exclusionType === ExclusionType.Break:
      return <DefaultBreakResponse daysRequested={daysRequested} endDate={endDate} />;
    default:
      return (
        <DefaultSelfExclusionResponse
          daysRequested={daysRequested}
          exclusionType={exclusionType}
          endDate={endDate}
        />
      );
  }
};

export default ExclusionResponseIT;
